const dimensionRect = function(doc, dimensions, mode="S") {
  doc.rect(dimensions.x, dimensions.y, dimensions.w, dimensions.h, mode)
}

const dimensionRoundedRect = function(doc, dimensions, mode="S") {
  doc.roundedRect(dimensions.x, dimensions.y, dimensions.w, dimensions.h, .1, .1, mode)
}

const dimensionEllipse = function(doc, dimensions, mode="S") {
  doc.ellipse((dimensions.x+dimensions.w/2), (dimensions.y+dimensions.h/2), dimensions.w/2, dimensions.h/2, mode)
}

const dimensionPolygon = function(doc, dimensions, cornerTopLeft, cornerTopRight, cornerBottomLeft, cornerBottomRight, mode="S") {
  const x = dimensions.x
  const y = dimensions.y
  const w = dimensions.w
  const h = dimensions.h

  const tlInset = cornerTopLeft * w
  const trInset = cornerTopRight * w
  const blInset = cornerBottomLeft * w
  const brInset = cornerBottomRight * w

  const points = [
    { x: x + tlInset,     y: y     },
    { x: x + w - trInset, y: y     },
    { x: x + w - brInset, y: y + h },
    { x: x + blInset,     y: y + h },
  ]

  doc.lines(
    [
      [points[1].x - points[0].x, 0],
      [points[2].x - points[1].x, points[2].y - points[1].y],
      [points[3].x - points[2].x, 0],
      [points[0].x - points[3].x, points[0].y - points[3].y],
    ],
    points[0].x, points[0].y,
    [1, 1],
    mode,
    true
  )
}

const hasCornerInsets = function(layer) {
  return (layer.cornerTopLeft || 0) > 0 ||
    (layer.cornerTopRight || 0) > 0 ||
    (layer.cornerBottomLeft || 0) > 0 ||
    (layer.cornerBottomRight || 0) > 0
}

export default {
  render(doc, layer, layerDimensions) {
    if(layer.strokePresent){
      layerDimensions.x += layer.strokeWidth/2
      layerDimensions.y += layer.strokeWidth/2
      layerDimensions.w -= layer.strokeWidth
      layerDimensions.h -= layer.strokeWidth
      const { r: strokeRed, g: strokeGreen, b: strokeBlue } = layer.strokeColor
      doc.setDrawColor(strokeRed, strokeGreen, strokeBlue)
      doc.setLineWidth(layer.strokeWidth)
    }
    if(layer.fillPresent) {
      const { r: fillRed, g: fillGreen, b: fillBlue } = layer.fillColor
      doc.setFillColor(fillRed, fillGreen, fillBlue)
    }

    let strokeFillMode
    if(layer.strokePresent && layer.fillPresent) {
      strokeFillMode = "DF"
    } else if(layer.strokePresent) {
      strokeFillMode = "S"
    } else if(layer.fillPresent) {
      strokeFillMode = "F"
    } else {
      return
    }

    if(layer.shape === "rectangle") {
      if(hasCornerInsets(layer)) {
        dimensionPolygon(doc, layerDimensions,
          layer.cornerTopLeft || 0,
          layer.cornerTopRight || 0,
          layer.cornerBottomLeft || 0,
          layer.cornerBottomRight || 0,
          strokeFillMode)
      } else {
        dimensionRect(doc, layerDimensions, strokeFillMode)
      }
    } else if(layer.shape === "roundedRectangle") {
      dimensionRoundedRect(doc, layerDimensions, strokeFillMode)
    } else if(layer.shape === "ellipse") {
      dimensionEllipse(doc, layerDimensions, strokeFillMode)
    }
  }
}